import { render, staticRenderFns } from "./ServiceAccessTag.vue?vue&type=template&id=543d034a"
import script from "./ServiceAccessTag.vue?vue&type=script&lang=js"
export * from "./ServiceAccessTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports